import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "evCableFilled"
const EvCableFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.875 3.375C8.289 3.375 8.625 3.711 8.625 4.125V5.25H8.82C9.333 5.25 9.75 5.667 9.75 6.18V8.25C9.75 9.78 8.604 11.04 7.125 11.226V15.767L7.13 15.85C7.134 15.926 7.143 16.038 7.162 16.174 7.2 16.45 7.275 16.804 7.419 17.15 7.562 17.494 7.762 17.797 8.03 18.012 8.287 18.217 8.647 18.375 9.188 18.375S10.088 18.217 10.345 18.012C10.613 17.797 10.813 17.494 10.956 17.149 11.1 16.805 11.176 16.449 11.213 16.174 11.233 16.038 11.241 15.926 11.246 15.85L11.249 15.767 11.25 15.75V8.272L11.24 8.138C11.236 8.027 11.233 7.872 11.241 7.688 11.26 7.325 11.32 6.823 11.507 6.308 11.693 5.79 12.016 5.233 12.572 4.807 13.135 4.376 13.876 4.125 14.812 4.125S16.49 4.375 17.054 4.807C17.609 5.233 17.933 5.79 18.119 6.307 18.305 6.824 18.366 7.326 18.383 7.689 18.392 7.872 18.39 8.027 18.385 8.138L18.376 8.272 18.376 8.287V12.773C19.855 12.958 21 14.22 21 15.75V17.82C21 18.333 20.584 18.75 20.07 18.75H19.875V19.875C19.875 20.289 19.539 20.625 19.125 20.625S18.375 20.289 18.375 19.875V18.75H16.875V19.875C16.875 20.289 16.539 20.625 16.125 20.625S15.375 20.289 15.375 19.875V18.75H15.179C14.666 18.75 14.25 18.333 14.25 17.82V15.75C14.25 14.22 15.395 12.958 16.875 12.773V8.208L16.879 8.168 16.881 8.152 16.886 8.072C16.889 7.999 16.891 7.889 16.884 7.757 16.873 7.487 16.828 7.146 16.71 6.817 16.59 6.492 16.41 6.205 16.14 5.997 15.877 5.798 15.47 5.626 14.812 5.626 14.156 5.625 13.749 5.796 13.486 5.998 13.215 6.205 13.034 6.492 12.916 6.818 12.798 7.145 12.753 7.487 12.741 7.757 12.734 7.888 12.736 7.997 12.74 8.071L12.744 8.152Q12.744 8.166 12.746 8.17L12.75 8.209V15.808Q12.747 15.858 12.742 15.939C12.737 16.05 12.723 16.2 12.7 16.382 12.649 16.738 12.549 17.227 12.34 17.726S11.805 18.766 11.282 19.184C10.748 19.61 10.053 19.875 9.188 19.875 8.322 19.875 7.627 19.611 7.092 19.184 6.57 18.766 6.243 18.224 6.034 17.726 5.826 17.226 5.726 16.738 5.676 16.381 5.651 16.2 5.638 16.049 5.632 15.94Q5.627 15.856 5.626 15.809L5.625 15.769V11.227C4.145 11.04 3 9.78 3 8.25V6.18C3 5.667 3.417 5.25 3.93 5.25H4.125V4.125C4.125 3.711 4.461 3.375 4.875 3.375S5.625 3.711 5.625 4.125V5.25H7.125V4.125C7.125 3.711 7.461 3.375 7.875 3.375" />
        </svg>
      }
    </span>
  )
}
export default EvCableFilledIcon
